import http from 'core/http/HttpService';

export default {
  data() {
    return {
      pendingFiles: [],
    };
  },

  methods: {
    downloadAndGetObjectURL(url, cb) {
      const success = ({ statusCode, data }) => {
        const url = window.URL.createObjectURL(data);
        cb(url);
      };

      const error = ({ statusCode, data }) => {
        console.log('Img error', data);
      };

      http.get({ url, blob: true })
        .then(success, error);
    },

    showModal() {
      this.$refs.uploadModal.show();
    },

    setProgress(file, loaded, total) {
      this.$refs.fileTable.setProgress(file, loaded, total);
    },

    setFileError(file, error) {
      this.$refs.fileTable.setError(file, error);
    },

    getUploadUrl(f) {
      console.error("Virtual method: please implement getUploadUrl()");
      throw Error("Virtual method: please implement getUploadUrl()");
    },

    getUploadHeaders(f) {
      /*
      //const tags = f.tags || [];
      return {
        'file.tags': JSON.stringify(tags.map(t => t.id))
      },
      */
      return undefined;
    },

    uploadCompleted(uploaded) {
      console.log("Uploaded:", uploaded);
    },

    upload(files) {
      const promises = [];
      const uploaded = {};

      for (let f of files) {
        const progress = (loaded, total) => {
          this.setProgress(f, loaded, total);
        }

        const success = ({ data }) => {
          this.setProgress(f, f.size, f.size);
          uploaded[f.id] = data;
          return Promise.resolve(true);
        }

        const error = ({ data }) => {
          this.setFileError(f, data);
          return Promise.reject(false);
        }

        this.loading = true;

        const url = this.getUploadUrl(f);
        const headers = this.getUploadHeaders(f);

        const prom = http.upload({
          url,
          headers,
          data: f,
          progress
        }).then(success, error);

        promises.push(prom);
      }

      const completedSuccess = () => {
        this.loading = false;
        this.uploadCompleted(uploaded);
        if (Object.keys(uploaded).length === this.pendingFiles.length) {
          this.$refs.uploadModal.hide();
          this.pendingFiles = [];
        }
      };

      const completedError = () => {
        this.loading = false;
        this.uploadCompleted(uploaded);
      };

      Promise.all(promises).then(completedSuccess, completedError);
    },
  }
}
